<template>
  <div class="public-sidebar">
    <!-- 見出し: 公共の宿 -->
    <div class="public-sidebar__title --top">公共の宿</div>

    <div class="public-sidebar__wrap --input-all">
      <!-- 宿泊地 -->
      <div class="public-sidebar__wrap">
        <p class="public-sidebar__heading">宿泊地</p>
        <SelectModal
          modalType="area"
          labelText="宿泊地"
          placeHoldText="都道府県・市区町村を選択"
          :isError="isError"
          :isLabelDisplay="false"
          :isFixedWidth="true"
          :isMultipleSelect="false"
          @inputed="setDestination"
        />
      </div>
      
      <!-- キーワード検索 -->
      <div class="public-sidebar__wrap">
        <p class="public-sidebar__heading">キーワード</p>
        <SearchKeyword
          :value="params.keyword"
          :isError="isError"
          :useSearchButton="false"
          @inputed="setKeyword"
        />
      </div>

      <!-- この条件で絞り込むボタン -->
      <div class="public-sidebar__wrap">
        <AppButton
          label="この条件で絞り込む"
          theme="black"
          @clicked="clicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchKeyword from '../SearchKeyword/'
import SelectModal from '../SelectModal/'
import AppButton from '@/components/elements/AppButton/'

export default {
  components: {
    SearchKeyword,
    SelectModal,
    AppButton
  },
  props: {
    isError: {
      type: Boolean,
      required: false,
      default: false
    }, // エラー状態
  },
  data() {
    return {
      params: {                   // BFFリクエスト用パラメータ
        numPeople: 1,             // 合計人数
        adultHeadCnt: 1,          // 大人の人数
        feeLower: '0',            // 下限金額
        feeUpper: '0',            // 上限金額
        facility: '',             // 施設タイプ
        roomType: '',             // 部屋タイプ
        mealCondition: '',        // 食事条件
        roomCondition: '',        // 部屋のこだわり
        serviceEquip: '',         // 設備・サービス
        usageMethod: '',          // 利用方法
        planByCompany: '',        // 提供会社
        checkInDate: '',          // 宿泊開始日
        areaLrgClassCd: '',       // 地方
        areaMidClassCd: '',       // 都道府県
        areaSmlClassCd: '',       // 市区町村
        areaDtlClassCd: '',       // エリア
        keyword: '',              // 検索キーワード
        stayNights: 1,            // 宿泊日数
        orderBy: 'PROPOSE',       // ソート条件（「おすすめ順」がデフォルト）
        category: 'publicStay',   // 公共の宿（publicStay）
        exUpperGradesHeadCnt: 0,  // 高学年
        exLowerGradesHeadCnt: 0,  // 低学年
        youjiAHeadCnt: 0,         // 食事・布団付き
        youjiBHeadCnt: 0,         // 食事のみ
        youjiCHeadCnt: 0,         // 布団のみ
        youjiDHeadCnt: 0,         // 食事・布団不要
        roomCnt: 1,               // 部屋数
      },
      isModalVisible: false       // こだわり条件モーダルの表示状態
    }
  },
  created() {
    this.initStateFromQuery()
  },
  methods: {
    /**
     * 「この条件で絞り込む」ボタンが押下されたら
     */
    clicked() {
      this.$emit('inputed', this.params)
    },
    /**
     * 初期値をクエリパラメータから取得し、反映
     */
    initStateFromQuery() {
      const query = this.$route.query
      const keys = Object.keys(this.params)

      keys.forEach(key => {
        this.params[key] = query?.[key] || this.params[key]
      })
    },
    /**
     * keywordを設定
     */
    setKeyword(value) {
      this.params.keyword = value
    },
    /**
     * SelectDestinationからemitされたobjectから値を設定
     */
    setDestination(obj) {
      this.params.areaLrgClassCd = obj.region_id
      this.params.areaMidClassCd = obj.large_id
      this.params.areaSmlClassCd = obj.medium_id
      this.params.areaDtlClassCd = obj.small_id
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.public-sidebar {

  &__wrap {
    padding: 0 1rem 1rem;

    &.--input-all {
      border: 2px solid $cool-gray-4;
      border-radius: .5rem;
      padding: 1rem 0 0;
    }
  }

  &__title {
    color: $black;
    font-weight: bold;
    line-height: 1.5;

    &.--top {
      border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
      font-size: 1.25rem;
      margin-bottom: 1.5rem;
    }
  }

  &__heading {
    font-size: .875rem;
    font-weight: bold;
    margin-bottom: .25rem;
  }

  &__block {
    &.--destination {
      align-items: center;
      align-content: stretch;
      display: flex;
      font-size: .75rem;
      line-height: 1.25;
      padding: .5rem 0;

      &::before {
        content: '設定中:';
        display: block;
        flex-shrink: 0;
        margin-right: .5rem;
      }
    }
  }

  &__rooms {
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    height: 2.5rem;
    width: 100%;
  }
}
</style>